// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3os_2","header":"PatientBlock_header__1DhFN","label":"PatientBlock_label__3ICkN","option":"PatientBlock_option__1htd_"};